export const debounce = (func, wait) => {
	let timeoutId;

	const debounced = (...args) => {
		if (timeoutId) {
			clearTimeout(timeoutId);
		}

		timeoutId = setTimeout(() => {
			func(...args);
		}, wait);
	};

	debounced.cancel = () => {
		if (timeoutId) {
			clearTimeout(timeoutId);
		}
	};

	return debounced;
};

// Utility function to round numbers to the next magnitude
const roundToNextTen = (n) => {
	const magnitude = 10 ** Math.floor(Math.log10(n));
	return Math.ceil(n / magnitude) * magnitude;
};

// Helper function to format numbers with appropriate suffixes
const formatWithSuffix = (n) => {
	const divisions = [
		{ value: 1e9, symbol: "B" },
		{ value: 1e6, symbol: "M" },
		{ value: 1e3, symbol: "K" },
	];

	const division = divisions.find((d) => n >= d.value);

	if (division) return (n / division.value).toFixed(2) + division.symbol;

	if (n < 10) return n.toFixed(2);

	if (n < 100) return n.toFixed(1);

	if (n < 1000) return Math.round(n).toString();

	return roundToNextTen(n).toString();
};

export const formatNumber = (num, suffix = "") => ({ [`formattedNumber${suffix}`]: formatWithSuffix(num) });